import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { AlertTriangle } from 'lucide-react';
export const ProblemSection = () => {
  return <SectionWrapper bg="bg-navy-800" data-id="element-102">
      <div className="space-y-8 text-gray-300 text-lg leading-relaxed" data-id="element-103">
        <div className="flex items-start gap-4 p-6 bg-navy-900/50 rounded-2xl border border-navy-800/50 shadow-inner" data-id="element-104">
          <AlertTriangle className="w-8 h-8 text-gold-500 flex-shrink-0 mt-1" data-id="element-105" />
          <p className="font-medium text-white text-xl" data-id="element-106">
            ¿Te han negado un préstamo para un auto, una tarjeta o el alquiler
            de una casa recientemente?
          </p>
        </div>

        <p data-id="element-107">
          No es falta de dinero, es que el sistema de crédito en este país tiene
          una "mancha" sobre tu nombre que te está costando miles de dólares en
          intereses invisibles. Mientras tú te preocupas por las llamadas de
          cobranza a las 8 de la mañana, los burós de crédito (Equifax, Experian
          y TransUnion) ganan dinero vendiendo tu información, sin importar si
          los errores en tu reporte son justos o no.
        </p>

        <div className="my-10 border-l-4 border-gold-500 pl-6 py-2" data-id="element-108">
          <h3 className="font-serif text-2xl md:text-3xl text-white font-bold mb-4" data-id="element-109">
            Tener un puntaje de crédito bajo en USA es una sentencia de pobreza
            silenciosa.
          </h3>
          <p data-id="element-110">
            Te obliga a pagar depósitos de renta más altos, intereses abusivos
            en seguros de auto y te cierra las puertas del progreso para tu
            familia.
          </p>
        </div>

        <p data-id="element-111">
          La mayoría de los hispanos creen que la única solución es esperar 7
          años a que las manchas "se borren solas" o pagarle a una agencia de
          reparación de crédito mensualidades de $100 dólares por un servicio
          lento y mediocre.
        </p>

        <p className="font-semibold text-white" data-id="element-112">
          La realidad es que esas agencias viven de mantenerte pagando por
          meses, haciendo lo que tú podrías resolver hoy mismo con una simple
          carta certificada.
        </p>
      </div>
    </SectionWrapper>;
};